/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BusinessConfigurationEnum {
    CUSTOMER = 'customer',
    SUPPLIER = 'supplier'
}
